import React from "react";
import { NavLink } from "react-router-dom";

const Navlink = ({ children, url, unidad, color }) => {
  let activeStyle = {
    background: color === 'green' ? '#dcf0db' : color === 'blue' ? '#d1e3f2' : "#f8dcdd",
  };
  return (
    <NavLink
      to={url}
      style={({ isActive }) => (isActive ? activeStyle : undefined)}
    >
      {!unidad
        ? ({ isActive }) => (
            <>
              {isActive ? (
                <div className="circle circle-active color-grey" />
              ) : (
                <div className="circle color-grey" />
              )}
              {children}
            </>
          )
        : children}
    </NavLink>
  );
};

export default Navlink;
